import { get } from 'lodash-es';

import { emptyObject } from 'ui-components/default-props/empty';

export const getSelectedFulfillmentPlanId = (state) => get(state, 'fulfillmentPlanId', '');
export const selectCostReviewGuid = (state) => get(state, 'costReviewJobGuid', emptyObject);
